import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import {
  Layers,
  Smartphone,
  Globe,
  Cloud,
  BarChart,
  Rocket,
  ArrowRight,
  ArrowLeft,
  BrainCircuit,
  Cloudy,
  ShieldCheck,
  Database,
  LaptopMinimalCheck,
  ArrowDownUp,
  Laptop

} from 'lucide-react';

const icons = {
  Layers: Layers,
  Smartphone: Smartphone,
  Globe: Globe,
  Cloud: Cloud,
  BarChart: BarChart,
  Rocket: Rocket,
  BrainCircuit: BrainCircuit,
  Cloudy: Cloudy,
  ShieldCheck: ShieldCheck,
  Database: Database,
  LaptopMinimalCheck: LaptopMinimalCheck,
  ArrowDownUp: ArrowDownUp,
  Laptop: Laptop
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white relative">


      <div className="container-custom">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start mb-20 gap-8">
          <div className="max-w-xl border-l-4 border-primary pl-8">
            <h2 className="text-4xl lg:text-5xl font-display font-medium text-navy mb-6 leading-tight">
              {content.services.title}
            </h2>
            <p className="text-navy/50 text-xl leading-relaxed max-w-lg font-medium">
              {content.services.subtitle}
            </p>
          </div>
          {/* <div className="flex gap-4">
            <button className="w-12 h-12 flex items-center justify-center rounded-full border border-navy/10 hover:bg-navy hover:text-white transition-all text-navy/40 hover:text-white">
              <ArrowLeft size={20} />
            </button>
            <button className="w-12 h-12 flex items-center justify-center rounded-full border border-navy/10 hover:bg-navy hover:text-white transition-all text-navy/40 hover:text-white">
              <ArrowRight size={20} />
            </button>
          </div> */}
        </div>

        {/* Card Grid with internal borders */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-navy/5">
          {content.services.items.map((service, idx) => {
            const Icon = icons[service.icon] || Rocket;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                className={`p-12 border-b border-navy/5 group relative transition-all hover:bg-navy/[0.01] ${(idx + 1) % 3 !== 0 ? 'lg:border-r' : ''
                  } ${(idx + 1) % 2 !== 0 ? 'md:border-r lg:md:border-r-0' : ''
                  }`}
              >
                <div className="mb-10 text-primary">
                  <Icon size={48} strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-bold mb-6 text-navy group-hover:text-primary transition-colors leading-tight">
                  {service.title}
                </h3>
                <p className="text-navy/50 text-base leading-relaxed mb-10 max-w-xs">
                  {service.description}
                </p>
                {/* <ArrowRight size={24} className="text-navy group-hover:text-primary transition-all group-hover:translate-x-2" /> */}
              </motion.div>
            );
          })}
        </div>

        {/* Bottom Buttons */}
        <div className="mt-20 flex flex-wrap gap-6 items-center">
          <a href="/contact"><Button className="bg-[#1E3A8A] text-white px-10 py-4 font-bold rounded-lg flex items-center gap-3 transition-transform hover:scale-105 shadow-xl shadow-blue-900/10">
            {content.services.cta1} <ArrowRight size={18} className="rotate-[-45deg]" />
          </Button></a>
          {/* <Button variant="outline" className="text-black px-10 py-4 border-2 border-navy text-navy font-bold rounded-lg transition-transform hover:scale-105">
            {content.services.cta2} <ArrowRight size={18} className="rotate-[-45deg]" />
          </Button> */}
        </div>
      </div>
    </section>
  );
};

export default Services;
